import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Casilleros, Diagrama, py } from "./Casilleros";
import { Informe, Alertas } from "./Informe";
import { NoComputan } from "./NoComputan";
import { VendedoresSinNombre } from "./VendedoresSinNombre";
import { ControlConsistencia } from "./ControlConsistencia";
import { CargaExcel } from "./CargaExcel";

export default function CargaCentral() {
  const [estado, setEstado] = useState(null);
  const [pv, setPv] = useState(null);
  const [hist, setHist] = useState([]);
  const [busy, setBusy] = useState(false);

  const cargar = useCallback(async () => {
    try {
      const [e, p, h] = await Promise.all([api.get("/carga-central/estado"), api.get("/carga-central/preview"), api.get("/carga-central/historial")]);
      setEstado(e.data); setPv(p.data); setHist(h.data.items || []);
    } catch (err) { if (err.response?.status === 403) toast.error("Sección reservada al administrador"); }
  }, []);
  useEffect(() => { cargar(); }, [cargar]);

  const listos = Object.values(estado?.casilleros || {}).filter((c) => c && c.estado === "listo").length;
  const confirmar = async () => {
    setBusy(true);
    try { const r = await api.post("/carga-central/confirmar"); toast.success("Datos actualizados"); const av = r.data?.cambios?.pagares?.aviso; if (av) toast.warning(`Pagarés: ${av}`, { duration: 12000 }); setPv(null); await cargar(); console.debug(r.data.cambios); }
    catch (e) { toast.error(e.response?.data?.detail || "No se pudo confirmar"); } finally { setBusy(false); }
  };
  const deshacer = async () => {
    if (!window.confirm("¿Deshacer la última carga confirmada?")) return;
    setBusy(true);
    try { await api.post("/carga-central/deshacer"); toast.success("Última carga deshecha"); await cargar(); }
    catch (e) { toast.error(e.response?.data?.detail || "No se pudo deshacer"); } finally { setBusy(false); }
  };
  const ult = estado?.ultima_carga;

  return (
    <div className="cc space-y-2" data-testid="carga-central">
      <h2 style={{ marginTop: 0 }}>1 · Archivos del día (5 casilleros)</h2>
      <Casilleros estado={estado} onCambio={cargar} />
      <h2>Clientes que no computan</h2>
      <CargaExcel onCambio={cargar} />
      <NoComputan onCambio={cargar} />
      <VendedoresSinNombre onCambio={cargar} />
      <ControlConsistencia />
      <h2>Cómo se vincula</h2>
      <Diagrama />
      <h2>2 · Vista previa del cruce · Informe general por coordinador</h2>
      <Informe pv={pv} />
      <h2>Alertas del cruce</h2>
      <Alertas pv={pv} onCambio={cargar} />
      <h2>Qué se actualiza al confirmar</h2>
      <ul className="cc-lista" data-testid="cc-actualiza">
        {(pv?.actualiza || []).length === 0 && <li>Nada pendiente: subí al menos un archivo.</li>}
        {(pv?.actualiza || []).map((t, i) => <li key={i}>{t}</li>)}
      </ul>
      <div className="cc-acciones">
        <button className="cc-btn verde" disabled={busy || !listos} onClick={confirmar} data-testid="cc-confirmar">Confirmar y actualizar ({listos} archivo{listos === 1 ? "" : "s"})</button>
        <button className="cc-btn tierra" disabled={busy || !ult || ult.deshecha} onClick={deshacer} data-testid="cc-deshacer">Deshacer última carga</button>
        <button className="cc-btn" disabled={busy} onClick={async () => { setBusy(true); try { const r = await api.post("/carga-central/reaplicar"); toast.success(`Re-aplicada (corte ${r.data.corte || "—"}): ${r.data.firmados} firmados, ${r.data.reemplazados} reemplazados`); await cargar(); } catch { toast.error("No se pudo re-aplicar"); } finally { setBusy(false); } }} data-testid="cc-reaplicar">Re-aplicar última carga</button>
        {ult && <span className="text-sm" style={{ color: "#5B6858" }}>Última carga: {ult.fecha?.slice(0, 16).replace("T", " ")} · corte {ult.corte}{ult.deshecha ? " · deshecha" : ""}</span>}
      </div>
      <h2>Historial de cargas</h2>
      <ul className="cc-lista" data-testid="cc-historial">
        {hist.length === 0 && <li>Sin cargas todavía.</li>}
        {hist.map((h) => (
          <li key={h.id}><span>{h.fecha?.slice(0, 16).replace("T", " ")} · corte {h.corte} · {h.usuario}{h.deshecha ? <span className="cc-pill" style={{ marginLeft: 8 }}>deshecha</span> : ""}</span>
            <span style={{ color: "#5B6858" }}>{Object.entries(h.cambios || {}).map(([k, v]) => `${k}: ${Object.entries(v).filter(([kk, vv]) => kk !== "periodo" && kk !== "aviso" && vv).map(([kk, vv]) => `${vv} ${kk}`).join(", ")}`).join(" · ")}</span>
            <span style={{ color: "#5B6858" }}>{(h.archivos || []).map((a) => `${a.nombre} (${a.filas} filas · US$ ${py(a.total)})`).join(" · ")}</span></li>
        ))}
      </ul>
    </div>
  );
}
